import kolmeoAppLaunch from "../../../assets/animations/kolmeo-app-launch.json";
import kolmeoCirclesLoader from "../../../assets/animations/kolmeo-circles-loader.json";
import kolmeoDotsLoader from "../../../assets/animations/kolmeo-dots-loader.json";
import kolmeoKeylineLoader from "../../../assets/animations/kolmeo-keyline-loader.json";
import kolmeoShapesLoader from "../../../assets/animations/kolmeo-shapes-loader.json";
export { kolmeoAppLaunch, kolmeoCirclesLoader, kolmeoDotsLoader, kolmeoKeylineLoader, kolmeoShapesLoader };
